module.exports = __webpack_public_path__ + "img/FR11600.b98c732a.png";